//Must run this file through Babel using Gulp file

//Handles Ajax requests for events
event_data = JSON.parse(event_data);

var COHevents = (function($){
	var _COHevents = {
		type: null,
		filterContainer: null,
		eventContainer: null,
		slickOptions: null,
		isGetting: false,
		storedEvents: {},
		isDebug: false,
		initNewsArchive: function() {
			_COHevents.type = 'news';

			//Debounce filter changes
			_COHevents.handleArchiveCategoryClick = debounce(_COHevents.handleArchiveCategoryClick, 1000);

			//Filter Listener
			$('.filters__cat').click(function(e){
				$(e.currentTarget).toggleClass('active');
				_COHevents.handleArchiveCategoryClick()
			});

			//Clear Listener
			$('.filters__clear').click(function(){
				let endpoint = window.location.origin + window.location.pathname;
				window.location = endpoint;
			});

			$('.coh-category-filter__title', $('.coh-category-filter')).click(_COHevents.collapseFilter);

		},
		initEventArchive: function(eventContainer) {
			_COHevents.type = 'events';

			_COHevents.eventContainer = eventContainer;

			//Debounce filter changes
			_COHevents.handleArchiveCategoryClick = debounce(_COHevents.handleArchiveCategoryClick, 1000);

			//Filter Listener
			$('.filters__cat').click(function(e){
				$(e.currentTarget).toggleClass('active');
				_COHevents.handleArchiveCategoryClick()
			});

			//Clear Listener
			$('.filters__clear').click(function(){
				let endpoint = window.location.origin + window.location.pathname;
				window.location = endpoint;
			});

			$('.coh-category-filter__title', $('.coh-category-filter')).click(_COHevents.collapseFilter);

			//Card Listeners
			_COHevents.handleCardClick();
		},
		initHome: function(eventContainer, slickOptions) {

			//Fails if the eventContainer does not exist
			if(!eventContainer.length) return

			//If slick options are pass then save them
			if(slickOptions) {
				_COHevents.slickOptions = slickOptions;
			}

			_COHevents.eventContainer = eventContainer;
			_COHevents.filterContainer = $('.coh-home-events__filter .filters');

			//Card Listeners
			_COHevents.handleCardClick();

			//Filter Listeners
			$('.filters__cat', _COHevents.filterContainer).click(_COHevents.toggleFilter);
			$('.filters__clear').click(_COHevents.clearFilter);

			//Filter Collapse
			$('.coh-category-filter__title', $('.coh-category-filter')).click(_COHevents.collapseFilter);

			//Debounce filter changes
			_COHevents.getEvents = debounce(_COHevents.getEvents, 1000);

		},
		collapseFilter: function(e) {
			//Filter Collapse Listener
			$('.coh-category-filter').toggleClass('show');
		},
		toggleFilter: function(e) {
			_COHevents.debug("Toggle Filter");
			$(e.currentTarget).toggleClass('active');

			_COHevents.toggleClearButton();
			_COHevents.setIsGetting(true);
			_COHevents.getEvents();
		},
		clearFilter: function(){
			_COHevents.debug("Clear Filter");
			$('.filters__cat', _COHevents.filterContainer).removeClass('active');
			$('.filters__clear').removeClass('show');

			_COHevents.setIsGetting(true);
			_COHevents.getEvents();
		},
		getEvents: function(){
			_COHevents.debug('Getting events');

			//Get Active categories
			var categories = _COHevents.getCategories().join(',');
			var today  = new Date().toISOString().split('T')[0];

			_COHevents.debug('Event Categories', categories);
			_COHevents.debug('Date', today);

			//Event Endpoint
			var endpoint = '/wp-json/wp/v2/events?per_page=10&datestart=' + today;

			//Add Categories
			if(categories) {
				endpoint += '&event_cat=' + categories;
			}

			//Embed feature image
			endpoint += '&_embed';

			//Get events
	        $.ajax({
	            type: 'GET',
	            cache: false,
	            url: endpoint,
	            dataType: 'json',
	            success: function (data) {
	            	_COHevents.debug(data);

	            	_COHevents.storeEvents(data);

	            	if(data.length) {
	            		console.log("PLace events")
	            		_COHevents.placeEvents(data);
	            	} else {
	            		console.log("no events")
	            		_COHevents.noEvents();
	            	}
	            },
	            error: function (xhr, ajaxOptions, thrownError) {
					_COHevents.setIsGetting(false);
	            }
	        });

		},
		getSingleEvent: function(id){
			_COHevents.debug('Getting Single Event', id);

			return new Promise(function(resolve, reject){

				//Event Endpoint
				var endpoint = '/wp-json/wp/v2/events/' + id;

				//Embed feature image
				endpoint += '?_embed';

				//Get events
		        $.ajax({
		            type: 'GET',
		            cache: false,
		            url: endpoint,
		            dataType: 'json',
		            success: function (data) {
		            	_COHevents.debug("getSIngleEvent Success", data);
		            	_COHevents.storeEvents(data);
		            	resolve(data);
		            },
		            error: function (xhr, ajaxOptions, thrownError) {
		            	reject();
						_COHevents.setIsGetting(false);
		            }
		        });

			});


		},
		placeEvents: function(events){
			_COHevents.debug("Placing Events");

			var container = _COHevents.eventContainer;

			if(_COHevents.slickOptions) {
				container.slick('unslick');
			}

			container.empty();
			$('.event-modal').remove();

			events.forEach(function(event){
				container.append(_COHevents.generateEventPreview(event));
			});

			if(_COHevents.slickOptions) {
				_COHevents.debug('Reinitialize Slick');
				container.slick(_COHevents.slickOptions);
			}

			$('.card', container).removeClass('init');
			_COHevents.setIsGetting(false);

		},
		noEvents: function(events){
			_COHevents.debug("Placing Events");

			var container = _COHevents.eventContainer;

			if(_COHevents.slickOptions) {
				container.slick('unslick');
			}

			container.empty();
			$('.event-modal').remove();

			container.append(`
				<div class="coh-events__noevents">
					<h4 class="coh-header-md-b">There are no events currently scheduled</h4>
				</div>
			`);

			_COHevents.setIsGetting(false);

		},
		generateEventPreview: function(event, contentSize = 100){
			_COHevents.debug("Generating Event Preview", event);
			if(!event) return;

			var color = '#16629a';
			if(event['event_cat'].length) {
				color = event_data['categories'][event['event_cat'][0]]['color'];
			}

			var featuredImage;
			var featuredImageHTML = '';
			if(event.featured_media) {
				featuredImage = event['_embedded']['wp:featuredmedia'][0];
				featuredImageHTML = `
					<div class="card-img-top" style="border-color: ${color}">
						<img src="${featuredImage.source_url}" alt="${featuredImage.alt_text}" data-object-fit="cover" />
					</div>`;
			}

			let eventDetails = _COHevents.getEventDetailObj(event);

			return `
				<div class="card card--event init" data-id="${event.id}">
					${featuredImageHTML}
					<div class="card-body">
						<h5 class="card-title">${eventDetails.title}</h5>
						<div class="card-details">
							<p>${eventDetails.date_start}</p>
							<p>${eventDetails.timeHTML}</p>
						</div>
						<div class="card-text">${eventDetails.content}</div>
					</div>
				</div>`;
		},
		handleCardClick: function() {
			_COHevents.debug("Adding Card listeners");

			_COHevents.eventContainer.on('click', '.card--event', function() {
				var eventID = $(this).data('id');
				if(!eventID) return;

				var event;

				//Check to see if we have the data already
				if(_COHevents.storedEvents.hasOwnProperty(eventID)) {

					//Get Event data from storedEvent object
					event = _COHevents.storedEvents[eventID];
					_COHevents.generateEventModal(event);

				} else {

					//Get Event data from server
					_COHevents.getSingleEvent(eventID).then(function(event){
						_COHevents.debug(event);
						_COHevents.generateEventModal(event);
					}).catch(function(err) {
						_COHevents.debug(err);
					});
				}
			});
		},
		handleArchiveCategoryClick: function(){

			let postCat = [];
			$('.filters__cat.active').each(function(){
				let catID = $(this).data('catid');
				postCat.push(catID);
			})

			let { origin, pathname } = window.location;
			let endpoint = origin;

			if(pathname.includes('page')) {
				endpoint += '/' + _COHevents.type + '/';
			} else {
				endpoint += pathname;
			}

			if(postCat.length) {

				if(_COHevents.type === 'news') {
					endpoint += '?cat=' + postCat.join(',');
				} else {
					endpoint += '?c=' + postCat.join(',');
				}

			}

			window.location = endpoint;

		},
		generateEventModal: function(event){
			_COHevents.debug("Generating Event Modal", event);
			if(!event) return;

			let eventDetails = _COHevents.getEventDetailObj(event, -1);

			$('body').append(
				`
					<div id="modal-${event.slug}" class="modal fade event-modal" tabindex="-1" role="dialog" aria-labelledby="eventmodal${event.slug}" aria-hidden="true">
						<div class="modal-dialog modal-dialog-centered" role="document">
							<div class="modal-content">
								<button type="button" class="close" data-dismiss="modal" aria-label="Close">
									<span aria-hidden="true">&times;</span>
								</button>
								<div class="modal-body">
									<div class="modal-body__left">
										<h5 class="card-title">${eventDetails.title}</h5>
										<div class="card-details">
											<p>${eventDetails.date_start}</p>
											<p>${eventDetails.timeHTML}</p>
											${eventDetails.contactHTML}
											${eventDetails.addressHTML}
										</div>
									</div>
									<div class="modal-body__right">
										${eventDetails.mapImage}
										${eventDetails.content}
									</div>
								</div>
							</div>
						</div>
					</div>`
			);

			var eventModal = $(`#modal-${event.slug}`);
			eventModal.modal().modal('show');
			eventModal.on('hidden.bs.modal', function (e) {
				$(this).modal('dispose');
				$(this).remove();
			})
		},
		getCategories: function() {
			_COHevents.debug("Getting Active Categories");
			var categories = [];

			$('.filters__cat.active', _COHevents.filterContainer).each(function(i) {
				categories.push($(this).data('catid'));
			});

			return categories;
		},
		setIsGetting: function(status) {
			_COHevents.isGetting = status;
			_COHevents.toggleLoader(status);
		},
		toggleLoader: function(status) {
			if(status) {
				_COHevents.eventContainer.addClass('coh-isLoading');
			} else {
				_COHevents.eventContainer.removeClass('coh-isLoading');
			}
		},
		toggleClearButton: function(){
			let active = $('.filters__cat.active', _COHevents.filterContainer).length;

			if(active) {
				$('.filters__clear').addClass('show');
			} else {
				$('.filters__clear').removeClass('show');
			}

		},
		storeEvents: function(events) {
			_COHevents.debug("Storing Events", events);
			var eventObject = {};

			if(events.isArray) {

				eventObject = events.reduce(function(carry, el) {
					carry[el.id] = el;
					return carry
				}, {})

			} else {

				eventObject[events.id] = events;

			}

			_COHevents.storedEvents = eventObject;
		},
		getEventDetailObj: function(event, contentSize = 100) {

			//Title
			var title = event.title.rendered;

			//Time
			var { date_start, time_start, time_end } = event.acf;
			var timeHTML = '';
			timeHTML += (time_start) ? time_start : '';
			timeHTML += (time_end && time_start) ? ` - ${time_end}` : '';

			//Meta
			var { address, contact_details } = event.acf;
			var mapImage = '';
			var addressHTML = formatAddress(address);
			var contactHTML = formatContactDetails(contact_details);

			//Get Map Static Map Image if Address is set
			if(addressHTML) {
				mapImage = getGoogleMapImage(address);
			}

			//Content
			var content = event.content.rendered;
			//If contentSize = -1, then we output the full content without truncating it
			if(contentSize != -1) {
				content = event.content.rendered.substr(0, contentSize);

				if(event.content.rendered.length > contentSize) {
					content += '...';
				}
			}

			return {
				title,
				date_start,
				timeHTML,
				addressHTML,
				contactHTML,
				mapImage,
				content
			}

		},
		debug: function() {
			if(_COHevents.isDebug) console.log(...arguments);
		}
	}

	return _COHevents;

})(jQuery)


function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};


function formatPhone( phone ) {
	var formattedPhone = `(${phone.substr(0,3)}) ${phone.substr(3,3)}-${phone.substr(6)}`
	return formattedPhone;
}


function formatContactDetails( details = {} ) {

	var contactDetails = Object.keys(details).reduce(function(carry, k){

		var value = details[k];

		if(value === '') return carry;

		var output;

		switch(k) {
			case 'phone':
				output = `<li>Phone: <a href="tel:+1${value}">${formatPhone(value)}</a></li>`;
			break;
			case 'email':
				output = `<li>Email: <a href="mailto:${value}">${value}</a></li>`;
			break;
			default:
				output = `<li>${value}</li>`;
			break;
		}

		return carry.push(output);
	}, []);

	if(contactDetails.length) {

		var contactHTML = `
			<ul class="event-modal__contact">
				${contactDetails.join('')}
			</ul>
		`;

		return contactHTML;

	} else {

		return '';

	}
}


function formatAddress( address = null ) {

	if(!address) return '';

	var {
		street_name,
		street_name_2,
		city,
		state,
		zip
	} = address;

	//If any of these are empty return nothing
	if( street_name === ''
		|| city === ''
		|| state === ''
		|| zip === '' ) {
		return '';
	}

	var place = `${street_name} ${city} ${state} ${zip}`.split(' ').join('+');

	var addressHTML = `
		<div class="event-modal__address">
			<h6>Address: </h6>
			<address>
				<a href="https://www.google.com/maps/place/${place}" target="_blank" rel="noopener">
					${`<p>${street_name}</p>`}
					${street_name_2 ? `<p>${street_name_2}</p>` : ''}
					${`<p>${city}, ${state} ${zip}</p>`}
				</a>
			</address>
		</div>`;

	return addressHTML;

}

function getGoogleMapImage(address) {

	var { street_name, city, state, zip } = address;
	var center = `${street_name} ${city} ${state} ${zip}`.split(' ').join('+');
	var imageURL = `https://maps.googleapis.com/maps/api/staticmap?markers=${center}&zoom=15&size=600x400&key=${event_data['google_maps']}`
	var mapImage = `
		<div class="event-modal__map">
			<a href="https://www.google.com/maps/place/${center}" target="_blank" rel="nooperner">
				<img src="${imageURL}"/>
			</a>
		</div>`;

	return mapImage;
}


function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split('&');

    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) == variable) {
            return decodeURIComponent(pair[1]);
        }
    }

    console.log('Query variable %s not found', variable);
}